import React from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import useEventListener from '@use-it/event-listener';

import {
    Account,
    Contact,
    DealTaxes,
    DealTaxesExpanded,
    DealTaxesTemplate,
    Disclaimer,
    LegalStructures,
    Login,
    Options,
    TaxOptimisation,
} from './pages';
import DealTaxesLayout from './pages/DealTaxes/DealTaxesLayout';
import LegalStructuresLayout from './pages/LegalStructures/LegalStructuresLayout';
import { Main } from './layouts';
import ComparisonTable from './pages/ComparisonTable/ComparisonTable';
import PrivateRouteWithLayout from './layouts/PrivateRouteWithLayout';
import Glossary from './pages/Glossary/Glossary';
import LegalStructuresTemplate from './pages/LegalStructuresTemplate/LegalStructuresTemplate';
import TaxOptimisationTemplate from './pages/TaxOptimisationTemplate/TaxOptimisationTemplate';
import StorageView from './pages/Storage/StorageView';
import Storage from './pages/Storage/Storage';
import StorageForm from './pages/Storage/StorageForm/StorageForm';
import Compliance from './pages/Compliance/Compliance';
import AccountLayout from './pages/Account/AccountLayout';
import Workflows from './pages/Workflows/Workflows';
import WorkflowsUpload from './pages/Workflows/WorkflowsUpload';
import StoragePreview from './pages/Storage/StoragePreview/StoragePreview';

const BACK_KEYS = ['Delete', 'Backspace'];

const AppRouter = () => {
    const location = useLocation();
    const navigate = useNavigate();

    function handler({ key, target }: any) {
        const path = location.pathname;

        if (
            path === '/' ||
            path === '/login' ||
            path === '/contact' ||
            path === '/disclaimer' ||
            target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA'
        )
            return;

        if (BACK_KEYS.includes(String(key))) {
            navigate(-1);
        }
    }

    useEventListener('keydown', handler);

    return (
        <Routes>
            <Route element={<Main />}>
                <Route path="/login" element={<Login />} />

                <Route path="/contact" element={<Contact />} />
                <Route element={<PrivateRouteWithLayout />}>
                    <Route path="/" element={<Options />} />
                    <Route path={'/disclaimer'} element={<Disclaimer />} />
                    <Route path={'/glossary'} element={<Glossary />} />
                    <Route path={'/dashboard'} element={<AccountLayout />}>
                        <Route path={''} element={<Account />} />
                        <Route path={'compliance'} element={<Compliance />} />
                    </Route>
                    <Route path={'/deal-taxes'} element={<DealTaxesLayout />}>
                        <Route index element={<DealTaxes />} />
                        <Route path={'expanded'} element={<DealTaxesExpanded />} />
                    </Route>
                    <Route path={'/legal-structures'} element={<LegalStructuresLayout />}>
                        <Route index element={<LegalStructures />} />
                        <Route path={'expanded'} element={<ComparisonTable />} />
                    </Route>
                    <Route path={'/storage'} element={<Workflows />} />
                    {/*<Route path={'/storage/view'} element={<Storage />} />*/}
                    <Route path={'/storage/:id'} element={<StorageView />} />
                    <Route path={'/storage/create'} element={<StorageForm />} />
                    <Route path={'/storage/preview'} element={<StoragePreview />} />
                    <Route path={'/tax-optimisation'} element={<TaxOptimisation />} />
                    <Route path={'/workflows'} element={<WorkflowsUpload />} />
                </Route>
            </Route>
            <Route path="/templates/deal-taxes" element={<DealTaxesTemplate />} />
            <Route path="/templates/legal-structures" element={<LegalStructuresTemplate />} />
            <Route path="/templates/tax-optimisation" element={<TaxOptimisationTemplate />} />
        </Routes>
    );
};

export default AppRouter;
